import { __extends } from "tslib";
import React from 'react';
import { AnalyticsListener, } from '@atlaskit/analytics-next';
import { sendEvent } from './analytics-web-client-wrapper';
var GenericAnalyticsListener = /** @class */ (function (_super) {
    __extends(GenericAnalyticsListener, _super);
    function GenericAnalyticsListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listenerHandler = function (event) {
            var _a = _this.props, client = _a.client, logger = _a.logger, channel = _a.channel, processEvent = _a.processEvent;
            if (!event.payload) {
                return;
            }
            logger.debug("Received " + channel + " event", event);
            var payload = processEvent(event, logger);
            logger.debug("Processed " + channel + " event", payload);
            if (payload) {
                sendEvent(logger, client)(payload);
            }
        };
        return _this;
    }
    GenericAnalyticsListener.prototype.render = function () {
        return (React.createElement(AnalyticsListener, { onEvent: this.listenerHandler, channel: this.props.channel }, this.props.children));
    };
    return GenericAnalyticsListener;
}(React.Component));
export default GenericAnalyticsListener;
//# sourceMappingURL=GenericAnalyticsListener.js.map